import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import dayjs from "dayjs";

const useStyles = makeStyles({
  card: {
    marginBottom: 12,
    border: "1px solid #e0e0e0",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
  },
  cardContent: {
    paddingBottom: 8,
  },
  header: {
    marginBottom: 12,
  },
  clientName: {
    fontWeight: 600,
    fontSize: 16,
    color: "#006EB3",
  },
  infoGrid: {
    marginTop: 8,
  },
  label: {
    fontSize: 12,
    color: "#666",
    marginBottom: 4,
  },
  value: {
    fontWeight: 500,
    fontSize: 14,
  },
  groupsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    marginTop: 4,
  },
  cardActions: {
    padding: "8px 16px",
    paddingTop: 0,
  },
  noneAssigned: {
    color: "#af4343",
    fontSize: 13,
    textAlign: "center",
    padding: "8px 0",
  },
});

interface AdminClientCardProps { client: { email?: React.ReactNode; first_name?: string; groups?: unknown[]; hasAssessments?: boolean; last_name?: string; start_date?: string; user?: React.ReactNode }; onViewAssigned?: () => void; }

export default function AdminClientCard({ client, onViewAssigned }: AdminClientCardProps): React.ReactElement {
  const classes = useStyles();

  const fullName =
    client.first_name || client.last_name
      ? `${client.first_name || ""} ${client.last_name || ""}`.trim()
      : "Not Specified";

  const startDate = dayjs(client.start_date).format("DD/MM/YYYY");

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <div className={classes.header}>
          <Typography className={classes.clientName}>{fullName}</Typography>
        </div>

        <Grid container spacing={2} className={classes.infoGrid}>
          <Grid item xs={12}>
            <Typography className={classes.label}>Email</Typography>
            <Typography className={classes.value}>{client.email}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography className={classes.label}>Group(s)</Typography>
            {client.groups!.length > 0 ? (
              <div className={classes.groupsContainer}>
                {client.groups!.map((group, index) => (
                  <Chip
                    key={index}
                    label={group}
                    size="small"
                    style={{
                      background: "#40628d",
                      color: "#f7f7f7",
                      fontSize: 12,
                    }}
                  />
                ))}
              </div>
            ) : (
              <Typography className={classes.value}>N/A</Typography>
            )}
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.label}>Coach</Typography>
            <Typography className={classes.value}>{client.user}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.label}>Enrol Date</Typography>
            <Typography className={classes.value}>{startDate}</Typography>
          </Grid>
        </Grid>
      </CardContent>

      <CardActions className={classes.cardActions}>
        {client.hasAssessments ? (
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onViewAssigned}
          >
            View Assigned
          </Button>
        ) : (
          <Typography className={classes.noneAssigned} component="div">
            None Assigned
          </Typography>
        )}
      </CardActions>
    </Card>
  );
}
